import React from 'react';
import { useContext } from 'react';
import { useState } from 'react';

const FeatureContext = React.createContext({featureContext: {id: -1, name: ''}, setFeatureContext: (v) => {}});

export const useFeatureContext = () => {
    return useContext(FeatureContext);
}

export const FeatureContextProvider = ({children}) => {
    const [state, setState] = useState({
        id: -1,
        name: ''
    });

    return (
        <FeatureContext.Provider value={{
            featureContext: state,
            setFeatureContext: setState
        }}>
            {children}
        </FeatureContext.Provider>
    )
}